import React from "react";
import { ChevronLeft } from "lucide-react";
import StepProgressBar from "@/Components/Common/StepProgressBar";

export default function CheckoutHeader({ onBack, title = "결제확인 단계", progressPercent = 100, showProgress = true }) {
  return (
    <>
      <div className="fixed top-0 left-1/2 z-50 w-full max-w-[640px] -translate-x-1/2 border-b border-gray-200/70 bg-white/85 px-4 pb-3 pt-[14px] backdrop-blur-md">
        <div className="grid h-10 grid-cols-[40px_1fr_40px] items-center">
          <button
            type="button"
            className="inline-flex h-10 w-10 cursor-pointer items-center justify-center text-gray-700 transition-transform duration-150 hover:text-gray-900 active:scale-[0.96]"
            aria-label="뒤로가기"
            onClick={onBack}
          >
            <ChevronLeft size={22} strokeWidth={2.2} />
          </button>
          <h1 className="m-0 text-center text-lg font-bold leading-tight text-gray-900" style={{ fontFamily: "Gmarket-B" }}>
            {title}
          </h1>
          <div aria-hidden="true" />
        </div>
        {showProgress && (
          <StepProgressBar progressPercent={progressPercent} className="mt-3" />
        )}
      </div>
      <div className={showProgress ? "h-[116px]" : "h-[68px]"} />
    </>
  );
}
